import React from 'react';
const gridLines = Array.from({
  length: 6
}, (_, index) => index);
type GridLinesTone = 'light' | 'dark';
interface GridLinesProps {
  tone?: GridLinesTone;
}
const toneColors: Record<GridLinesTone, {
  line: string;
  mark: string;
}> = {
  light: {
    line: 'bg-[#EDEDEA]',
    mark: 'bg-[#DCDCD8]'
  },
  dark: {
    line: 'bg-[#1E1E1E]',
    mark: 'bg-[#262626]'
  }
};
export function GridLines({
  tone = 'light'
}: GridLinesProps) {
  const colors = toneColors[tone];
  return <div aria-hidden="true" className="pointer-events-none absolute inset-y-0 left-1/2 w-full max-w-container -translate-x-1/2 px-6 md:px-10" data-id="element-410" data-mp="223jutj1n7vvg">
      <div className="flex h-full justify-between" data-id="element-411" data-mp="1s8i5am3ggrsc">
        {gridLines.map(line => <div key={line} className={`relative h-full w-px ${colors.line}`} data-id="element-412" data-mp="1x7bjyhuhaou3">
            <span className={`absolute bottom-0 left-1/2 h-px w-2 -translate-x-1/2 ${colors.mark}`} data-id="element-413" data-mp="1j5z6cd2sizbd" />
            <span className={`absolute bottom-0 left-1/2 h-2 w-px -translate-x-1/2 ${colors.mark}`} data-id="element-414" data-mp="1o63mu33p7u1l" />
          </div>)}
      </div>
    </div>;
}